import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { media } from "utils/style";

import Button from "common-components/Buttons";
import Modal from "common-components/Modal/Modal";

const DeleteFileModal = ({ handleClick, handleCancelClick, modalContent, ...props }) => {
  return (
    <Modal contentLabel="delete file request modal">
      <Div>
        <h2 style={{ maxWidth: "349px", marginBottom: "35px" }}>{modalContent.section_title}</h2>
      </Div>

      <Button onClick={() => handleClick("delete")} background={modalContent.buttons[0].type}>
        {modalContent.buttons[0].text}
      </Button>
      <Button onClick={handleCancelClick} background={modalContent.buttons[1].type}>
        {modalContent.buttons[1].text}
      </Button>
    </Modal>
  );
};

export default DeleteFileModal;

DeleteFileModal.propTypes = {
  handleClick: PropTypes.func.isRequired,
  handleCancelClick: PropTypes.func.isRequired
};

const Div = styled.div`
  width: 546px;

  ${media.mobile`
        width: auto;
    `};
`;
